import memoize from 'lodash/memoize';

import {OAUTH_URL} from '../config/config';

class SpotifyOAuth {
  constructor() {
    this.getToken = memoize(this.getToken);
    this.clearTokenCache = this.clearTokenCache.bind(this);
  }

  async getToken() {
    try {
      const response = await fetch(`${OAUTH_URL}/v1/access-token`, {
        credentials: 'include',
      });

      if (!response.ok) {
        this.clearTokenCache();
        return '';
      }

      const {access_token: token, expires_in: expiresIn} = await response.json();

      if (!token) {
        this.clearTokenCache();
        return '';
      }

      setTimeout(this.clearTokenCache, expiresIn * 1000 * 0.9);

      return token;
    } catch (err) {
      this.clearTokenCache();
      throw err;
    }
  }

  clearTokenCache() {
    this.getToken.cache.clear();
  }

  async request(path, options = {}, tokenRequired = true) {
    const token = await this.getToken();

    if (tokenRequired && !token) {
      throw new Error('Token not received');
    } else {
      const headers = {
        Accept: 'application/json',
        ...options.headers,
      };

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      return fetch(path, {
        ...options,
        headers,
      });
    }
  }

  async getJSON(path, options, tokenRequired = true) {
    const response = await this.request(path, options, tokenRequired);

    if (!response.ok) {
      throw new Error(`${response.status}, for path ${path}`);
    }

    return response.json();
  }
}

export default new SpotifyOAuth();
